(() => {
  const sectionId = document.currentScript?.dataset.sectionId;
  if (!sectionId) return;

  function initialize() {
    const root = document.querySelector(`[data-product-root="${sectionId}"]`);
    const gallery = root?.querySelector('.product-media');
    const main = gallery?.querySelector('.splide--product');
    if (!main || root.dataset.ckJpGalleryGestures) return;
    root.dataset.ckJpGalleryGestures = 'true';
    const desktop = window.matchMedia('(min-width: 990px)');
    const getSlides = () => [...main.querySelectorAll('.feature-media-item[data-media-id]')];
    const getState = () => window.Alpine?.$data?.(root);
    const mounted = instance => instance?.Components?.Controller &&
      !instance.state.is([window.Splide.STATES.CREATED, window.Splide.STATES.DESTROYED]);

    function move(direction) {
      const state = getState();
      if (!state || state.currentMediaId == null) return false;
      const slides = getSlides();
      const instance = window.slideshows?.[main.id];
      let current = !desktop.matches && mounted(instance)
        ? instance.index
        : slides.findIndex(slide => slide.dataset.mediaId === String(state.currentMediaId));
      if (current < 0) current = 0;
      const next = Math.max(0, Math.min(slides.length - 1, current + direction));
      if (next === current || !slides[next]) return false;
      state.currentMediaId = Number(slides[next].dataset.mediaId);
      if (!desktop.matches && mounted(instance)) instance.go(next);
      gallery.querySelectorAll('[id^="slideshow-thumbnails-"], [id^="slideshow-mobile-thumbnails-"]').forEach(rail => {
        const thumbnails = window.slideshows?.[rail.id];
        if (mounted(thumbnails)) thumbnails.go(next);
      });
      return true;
    }

    let lastWheel = 0;
    let distance = 0;
    let wheelMoved = false;
    gallery.addEventListener('wheel', event => {
      if (event.ctrlKey || !event.target.closest('.splide__track')) return;
      const horizontal = event.deltaX || (event.shiftKey ? event.deltaY : 0);
      const vertical = event.shiftKey ? 0 : event.deltaY;
      if (Math.abs(horizontal) < 1 || Math.abs(horizontal) < Math.abs(vertical) * 1.2) return;
      if (event.cancelable) event.preventDefault();
      const now = performance.now();
      if (now - lastWheel > 180) {
        distance = 0;
        wheelMoved = false;
      }
      lastWheel = now;
      if (wheelMoved) return;
      if (Math.sign(distance) !== Math.sign(horizontal)) distance = 0;
      const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? main.clientWidth : 1;
      distance += horizontal * unit;
      if (Math.abs(distance) < 32) return;
      move(distance > 0 ? 1 : -1);
      wheelMoved = true;
    }, { passive: false });

    let pointer = null;
    let suppressClickUntil = 0;
    const track = main.querySelector('.splide__track');
    track.addEventListener('pointerdown', event => {
      if (!desktop.matches || !event.isPrimary || event.button !== 0 ||
          event.target.closest('video, iframe, model-viewer, input, select, button')) return;
      pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, horizontal: false };
    });
    track.addEventListener('pointermove', event => {
      if (!pointer || event.pointerId !== pointer.id) return;
      const dx = event.clientX - pointer.x;
      const dy = event.clientY - pointer.y;
      if (!pointer.horizontal) {
        if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) {
          pointer = null;
          return;
        }
        if (Math.abs(dx) < 12 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        pointer.horizontal = true;
        track.setPointerCapture(event.pointerId);
      }
      if (event.cancelable) event.preventDefault();
    });
    track.addEventListener('pointerup', event => {
      if (!pointer || event.pointerId !== pointer.id) return;
      const dx = event.clientX - pointer.x;
      if (pointer.horizontal) {
        suppressClickUntil = performance.now() + 400;
        if (Math.abs(dx) >= 40) move(dx < 0 ? 1 : -1);
      }
      pointer = null;
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
    });
    track.addEventListener('pointercancel', () => { pointer = null; });
    track.addEventListener('dragstart', event => {
      if (desktop.matches && event.target.closest('img')) event.preventDefault();
    });
    track.addEventListener('click', event => {
      if (performance.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }

  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
